<div class="modal-overlay" (click)="closeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="title-section">
          <div class="icon-container">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6668 5.41675L7.50016 14.5834L3.3335 10.4167" stroke="#1C64F2" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <h2 class="title">Servicio solicitado</h2>
          <span class="countdown-badge">{{ timeRemaining }}s</span>
        </div>
        <button class="close-btn" (click)="closeModal()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <!-- Progress bars -->
      <div class="progress-container">
        <div class="progress-bar-background">
          <div class="progress-bar-fill" [style.width.%]="progressPercentage"></div>
        </div>
      </div>
    </div>

    <!-- Separator -->
    <div class="separator" *ngIf="showFullDetails"></div>

    <!-- Service Details -->
    <div class="service-details" *ngIf="showFullDetails">
      <!-- Origin and Destination -->
      <div class="locations-group">
        <!-- Origin -->
        <div class="location-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 13.5C13.6569 13.5 15 12.1569 15 10.5C15 8.84315 13.6569 7.5 12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 12.1569 10.3431 13.5 12 13.5Z"
              stroke="#7F8694" stroke-width="1.5" />
            <path
              d="M12 21C16 17 19 13.4183 19 10.5C19 6.63401 15.866 3.5 12 3.5C8.13401 3.5 5 6.63401 5 10.5C5 13.4183 8 17 12 21Z"
              stroke="#7F8694" stroke-width="1.5" />
          </svg>
          <div class="location-text">
            <p class="location-label">Origen: {{ getOriginText() }}</p>
            <p class="location-address">{{ getOriginDescription() }}</p>
          </div>
        </div>

        <!-- Destination -->
        <div class="location-item destination">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 13.5C13.6569 13.5 15 12.1569 15 10.5C15 8.84315 13.6569 7.5 12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 12.1569 10.3431 13.5 12 13.5Z"
              stroke="#7F8694" stroke-width="1.5" />
            <path
              d="M12 21C16 17 19 13.4183 19 10.5C19 6.63401 15.866 3.5 12 3.5C8.13401 3.5 5 6.63401 5 10.5C5 13.4183 8 17 12 21Z"
              stroke="#7F8694" stroke-width="1.5" />
          </svg>
          <div class="location-text">
            <p class="location-label">Destino: {{ getDestinationText() }}</p>
            <p class="location-address">{{ getDestinationDescription() }}</p>
          </div>
          <!-- Connection line -->
          <div class="connection-line">
            <svg width="2" height="27" viewBox="0 0 2 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1" cy="1" r="1.5" fill="#7F8694" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Always Visible Info -->
      <div class="always-visible-info">
        <!-- Phone -->
        <div class="info-item" *ngIf="serviceData?.phone">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22 16.92V19.92C22.01 20.49 21.54 20.96 20.97 20.97C10.05 21.26 3.03 14.24 3 3.03C3 2.46 3.47 2 4.03 2H7.03C7.6 2 8.07 2.47 8.07 3.03C8.18 5.92 8.76 8.73 9.78 11.37C9.94 11.72 9.84 12.15 9.56 12.43L7.84 14.15C9.53 17.46 12.54 20.47 15.85 22.16L17.57 20.44C17.85 20.16 18.28 20.06 18.63 20.22C21.27 21.24 24.08 21.82 26.97 21.93C27.54 21.94 28.01 22.41 28.01 22.97V25.97"
              stroke="#7F8694" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div class="info-text">
            <p class="info-label">Teléfono</p>
            <p class="info-value">{{ serviceData!.phone }}</p>
          </div>
        </div>

        <!-- Client Name -->
        <div class="info-item" *ngIf="getClientName()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
              stroke="#7F8694" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="12" cy="7" r="4" stroke="#7F8694" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <div class="info-text">
            <p class="info-label">Cliente</p>
            <p class="info-value">{{ getClientName() }}</p>
          </div>
        </div>

        <!-- Reserve Date -->
        <div class="info-item" *ngIf="serviceData?.reserve && serviceData?.reserveDate">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="#7F8694" stroke-width="1.5" />
            <path d="M16 2V6M8 2V6M3 10H21" stroke="#7F8694" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <div class="info-text">
            <p class="info-label">Fecha y hora de reserva</p>
            <p class="info-value">{{ getReserveDateTime() }}</p>
          </div>
        </div>
      </div>

      <!-- Additional details -->
      <div class="additional-details" *ngIf="showFullDetails">
        <!-- Priority -->
        <div class="info-item" *ngIf="serviceData?.priority">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              stroke="#EBA747" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div class="info-text">
            <p class="info-label">Servicio prioritario</p>
            <p class="info-value priority-badge">Sí</p>
          </div>
        </div>

        <!-- Passengers -->
        <div class="info-item">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" stroke="#7F8694" stroke-width="1.5" />
            <path d="M5 20C5 16.6863 7.68629 14 11 14H13C16.3137 14 19 16.6863 19 20" stroke="#7F8694"
              stroke-width="1.5" />
          </svg>
          <div class="info-text">
            <p class="info-label">Pasajeros</p>
            <p class="info-value">{{ serviceData?.persons || 1 }}</p>
          </div>
        </div>

        <!-- Notes -->
        <div class="info-item" *ngIf="serviceData && serviceData.note">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 4.5H14.5L18.5 8.5V19.5H5V4.5Z" stroke="#7F8694" stroke-width="1.5" />
            <path d="M14.5 4.5V8.5H18.5" stroke="#7F8694" stroke-width="1.5" />
          </svg>
          <div class="info-text">
            <p class="info-label">Notas</p>
            <p class="info-value">{{ serviceData.note }}</p>
          </div>
        </div>

        <!-- Extras -->
        <ng-container *ngIf="serviceData && serviceData.extra && serviceData.extra.length > 0">
          <div class="info-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="4" width="16" height="16" rx="2" stroke="#7F8694" stroke-width="1.5" />
              <path d="M8 12H16M12 8V16" stroke="#7F8694" stroke-width="1.5" />
            </svg>
            <div class="info-text">
              <p class="info-label">Extras</p>
              <div class="extras-tags">
                <span class="extra-tag" *ngFor="let extra of serviceData.extra">{{ 'services.' + extra | translate
                  }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Separator -->
    <div class="separator" *ngIf="showFullDetails"></div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-buttons-container">
        <!-- Quick Duplicate Panel (posición absoluta sobre el botón duplicar) -->
        <div class="quick-duplicate-panel-absolute" *ngIf="showQuickDuplicatePanel">
          <p class="panel-title">Selecciona cantidad</p>
          <div class="numbers-grid">
            <div class="numbers-row">
              <button *ngFor="let num of getFirstLineNumbers()" class="number-btn" [class.highlight]="num > 5"
                (click)="onQuickDuplicate(num)">
                {{ num }}
              </button>
            </div>
            <div class="numbers-row">
              <button *ngFor="let num of getSecondLineNumbers()" class="number-btn" [class.highlight]="num > 5"
                (click)="onQuickDuplicate(num)">
                {{ num }}
              </button>
            </div>
          </div>
        </div>

        <button class="btn btn-primary" (click)="toggleQuickDuplicatePanel()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M3.33334 10H2.66668C2.31305 10 1.97391 9.85952 1.72386 9.60947C1.47382 9.35943 1.33334 9.02029 1.33334 8.66666V2.66666C1.33334 2.31304 1.47382 1.9739 1.72386 1.72385C1.97391 1.47381 2.31305 1.33333 2.66668 1.33333H8.66668C9.0203 1.33333 9.35944 1.47381 9.60949 1.72385C9.85953 1.9739 10 2.31304 10 2.66666V3.33333"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Duplicar (D)
        </button>
        <button class="btn btn-secondary" (click)="showFullDetails ? closeModal() : toggleDetails()">
          <svg *ngIf="!showFullDetails" width="16" height="16" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M1 8C1 8 3.66667 3 8 3C12.3333 3 15 8 15 8C15 8 12.3333 13 8 13C3.66667 13 1 8 1 8Z"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="8" cy="8" r="2" stroke="currentColor" stroke-width="1.5" />
          </svg>
          <svg *ngIf="showFullDetails" width="16" height="16" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          {{ showFullDetails ? 'Cerrar' : 'Ver detalles' }}
        </button>
      </div>
    </div>
  </div>
</div>